import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {catchError, Observable} from 'rxjs';
import {GridGetService, GridServiceParams, GridServiceResponse} from 'src/app/shared/model/page-grid';
import {removeEmptyParams} from 'src/infrastructure/helper/remove-empty-params';
import {KtPaymentsFilterService} from './kt-payments-filter.service';
import {IKtTravelerPaymentListItem} from '../interfaces/kt-trip.interface';
import moment from 'moment';

@Injectable({providedIn: 'root'})
export class KtPaymentsGridService implements GridGetService<IKtTravelerPaymentListItem> {
  private readonly baseUrl = 'tmt/sales-orders/kt-traveler-payments';
  private readonly http = inject(HttpClient);
  private readonly filterService = inject(KtPaymentsFilterService);

  public salesOrderId: number | null = null;

  getItems({page, sort}: GridServiceParams): Observable<GridServiceResponse<IKtTravelerPaymentListItem>> {
    const filters = this.filterService.filtersValue();

    const params: Record<string, string | number | boolean | string[] | number[]> = {
      pageSize: page?.pageSize || 25,
      pageNumber: (page?.pageIndex || 0) + 1,
      propertyName: sort?.active || '',
      orderKey: sort?.direction || '',
      tripReference: filters?.TripReference ?? '',
      travelerName: filters?.TravelerName ?? '',
      productTypeName: filters?.ProductTypeName ?? '',
      paymentDateFrom: filters?.PaymentDateFrom ? moment(filters.PaymentDateFrom).format('YYYY-MM-DD') : '',
      paymentDateTo: filters?.PaymentDateTo ? moment(filters.PaymentDateTo).format('YYYY-MM-DD') : '',
      ...(this.salesOrderId ? {salesOrderId: this.salesOrderId} : {}),
    };

    removeEmptyParams(params);

    return this.http.get<GridServiceResponse<IKtTravelerPaymentListItem>>(this.baseUrl, {params: {...params}})
      .pipe(catchError((error: HttpErrorResponse) => {
        throw new Error(error?.message || 'Server error');
      }));
  }
}
